export const getDataFromId = (nodes, nodeId) => {
  const node = nodes.find((node) => node.id === nodeId)
  return node ? node.data : null
}

export const getNodeFromId = (nodes, nodeId) => {
  const node = nodes.find((node) => node.id === nodeId)
  return node ? node : null
}